<template>
    <div class="contanier">
        <div class="contanier_mask"></div>

        <div class="loginForm">
            <div class="form_header">
                <!-- <img class="logoImg" src="@/assets/image/index-banner-Icon.webp" alt="" width="40" height="50" > -->
                <img class="logoImg2" src="@/assets/image/hepha-logo-black2.jpg" alt="" width="200" height="70" >
                <a-select 
                    v-model="language"
                    :style="{width:'120px',float:'right',marginTop:'10px'}" 
                    placeholder="Select"
                    @change="changeSelect"
                >
                    <a-option value="en">English</a-option>
                    <!-- <a-option value="de">Deutsch</a-option> -->
                    <a-option value="zh">简体中文</a-option>
                </a-select>
                <div class="text">{{ $t('login.title') }}</div>
                <div class="subText">{{ $t('login.subTitle') }}</div>
            </div>
            <div>
                <a-form
                    :model="form"
                    :style="{marginTop: '10px' }"
                >
                    <a-form-item
                        field="name"
                        :hide-label="true"
                        :help="emailMsg"
                        :validate-status="email_status"
                        feedback
                    >
                        <a-input
                            v-model="form.email"
                            allow-clear
                            :placeholder="$t('base.email')"
                        />
                    </a-form-item>
                    <a-form-item
                        field="password"
                        :hide-label="true"
                        :help="pdwMsg"
                        :validate-status="password_status"
                        feedback
                    >
                        <a-input-password
                            v-model="form.password"
                            allow-clear
                            :placeholder="$t('base.password')"
                        />
                    </a-form-item>

                    <a-button type="primary" class="signInBtn" :disabled="loading" @click="beforeSignIn">
                        <span v-if="!loading">{{ $t('base.signIn') }}</span>  
                        <a-spin v-else>Logging in...</a-spin>
                    </a-button>

                    <div class="psdTool">
                        <a-checkbox v-model="remember" class="remember" @change="rememberPassword">{{ $t('login.remmenber') }}</a-checkbox>
                        <!-- <router-link to="/ForgetPwd" class="forget">{{ $t('login.fogget') }}</router-link> -->
                    </div>

                    <a-button type="outline" class="signInBtn" @click="feishuLogin">
                        <icon-lark-color :size="25" style="margin-right:15px"/> {{ $t('base.larkLogin') }}
                    </a-button>
                </a-form>

                <Verify
                    class="verify"
                    @success="success" 
                    mode="pop" 
                    captchaType="blockPuzzle"
                    :imgSize="{ width: '408px', height: '155px' }"
                    ref="verifyRef"
                ></Verify>
            </div>
            <div class="form_footer">
                {{ $t('login.bottomTitle') }} <router-link to="/Register" class="link">{{ $t('login.create') }}</router-link> 
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, toRefs, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { LoginApi } from '@/api/LoginApi.js';
    import { RoleApi } from '@/api/RoleApi.js';
    import { Message } from '@arco-design/web-vue';
    import jwt_decode from "jwt-decode";
    import { useI18n } from 'vue-i18n';
    import Verify from "@/components/verifition/Verify";

    const router = useRouter()
    const { t } = useI18n()
    const loading = ref(false)
    const language = localStorage.getItem('locale')? ref(localStorage.getItem('locale')) : ref('en')
    const emailMsg = ref('')
    const pdwMsg = ref('')
    const email_status = ref('')
    const password_status = ref('')
    const form = reactive({
        captcha_verification:'',
        email:'',
        password:''
    })
    const remember = ref(false)
    const verifyRef = ref(null)

    const changeSelect = (val)=>{
        localStorage.setItem('locale',val)
        location.reload()
    }

    const feishuLogin = ()=>{
        router.push('/FeishuLogin')
    }

    const vaild = ()=>{
        if(!form.email && !form.password){
            emailMsg.value = t('login.emailEmpty')
            email_status.value = 'error'
            pdwMsg.value = t('login.passwordEmpty')
            password_status.value = 'error'

            return false
        }else if(!form.email){
            emailMsg.value = t('login.emailEmpty')
            email_status.value = 'error'
            return false
        }else if(!form.password){
            pdwMsg.value = t('login.passwordEmpty')
            password_status.value = 'error'
            return false
        }

        return true
    }

    const beforeSignIn = ()=>{
        if(!vaild()) return

        if(form.captcha_verification == ''){
            verifyRef.value.show()
            return
        }
    }

    // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
    const success = (params)=>{ 
        console.log(params,'params')
        form.captcha_verification = params.captchaVerification
        signIn()
    }

    // 登录
    const signIn = async ()=>{
        loading.value = true
        let res = await LoginApi.getInstance().login(form)
        if(res.code == 0){
            let userInfo = jwt_decode(res.access_token)
            sessionStorage.setItem('token',res.access_token)
            rememberPassword()
            getRole(userInfo)
        }else{
            Message.error(res.msg)
            loading.value = false
            form.captcha_verification = ''
        }
    }

    const rememberPassword = ()=>{
        if(remember.value){
            localStorage.setItem('loginInfo',JSON.stringify(form))
        }else{
            localStorage.removeItem('loginInfo')
        }
    }

    const getRole = async (userInfo)=>{
        let res = await LoginApi.getInstance().getRole(userInfo.id)
        if(res.code == 0){
            loading.value = false
            userInfo.role = res.data.join(',')
            sessionStorage.setItem('userInfo',JSON.stringify(userInfo))

            getMenuBtnByRole()
        }else{
            Message.error(res.msg)
            loading.value = false
        }
    }

    const getMenuBtnByRole = async()=>{
        if(sessionStorage.getItem('userInfo')){
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            let res = await RoleApi.getInstance().getMenuBtnByRole(userInfo.role)
            if(res.code == 0){
                let btnData = [], menuId = []
                res.data.forEach(i=>{
                    i.menu.forEach(k=>{
                        if(k.menu_category == 2){
                            btnData.push(k)
                        }
                    })
                    i.menuId.forEach(k=>{
                        if(!menuId.includes(k)){
                            menuId.push(k)
                        }
                    })
                })

                // console.log(btnData,'btnData',menuId)
                let permissionBtns = []
                btnData.forEach(i=>{
                    if(menuId.includes(i.id)){
                        permissionBtns.push(i.menu_name)
                    }
                })
                let arr = []
                permissionBtns.forEach(i=>{
                    if(!arr.includes(i)){
                        arr.push(i)
                    }
                })
                sessionStorage.setItem('permissionBtns',JSON.stringify(arr))
                if(userInfo.role == '6' || userInfo.role == '7'){ // 如果用户是ZU，则仅能查看出库管理页面
                    router.replace('/Outbounds/StockOutList')
                }else if(userInfo.role == '17'){ // 如果用户是supply_chain角色，则仅能查看产品管理和库存可用性模块
                    router.replace('/Product/ProductList')
                }else if(sessionStorage.getItem('toPage')){
                    let url = sessionStorage.getItem('toPage')
                    router.replace(url)
                }else{
                    router.replace('/OrderList/OrderList')
                }
                
            }else{
                Message.error(res.msg)
            }
        }
    }

    watch(()=>form.email, (val)=>{
        if(val){
            emailMsg.value = ''
            email_status.value = ''
        }
    })

    watch(()=>form.password, (val)=>{
        if(val){
            pdwMsg.value = ''
            password_status.value = ''
        }
    })

    onMounted(()=>{
        if(localStorage.getItem('loginInfo')){
            form.email = JSON.parse(localStorage.getItem('loginInfo')).email
            form.password = JSON.parse(localStorage.getItem('loginInfo')).password
            remember.value = true
        }
    })


</script>

<style lang="less" scoped>
.contanier{
    width: 100%;
    height: 100vh;
    background:url('@/assets/image/login_bg.webp') center / cover no-repeat;

    .contanier_mask{
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0.6;
    }

    .loginForm{
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1001;
        margin-left: -35vh;
        margin-top: -40vh;
        padding: 40px 45px;
        width: 70vh;
        height: auto;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px; 

        .logoImg2{
            margin-left: -25px;
            vertical-align: top;
            margin-top:18px;
        }

        .text{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 600;
        }
        .subText{
            margin-top: 5px;
            font-weight: 300;
            color: #333;
        }

        /deep/ .arco-form-item-content-wrapper{
            margin-top: 15px;
        }

        /deep/ .arco-input-wrapper .arco-input{
            height: 40px;
        }

        /deep/ button:focus, 
        /deep/ button:focus-visible{
            outline: none;
        }

        .signInBtn{
            margin-top: 20px;
            height: 50px;
        }

        .psdTool{
            display: flex;
            margin-top: 15px;
            .remember{
                display: flex;
                flex: 1;
                color: #666;
            }
            .forget{
                display: flex;
                align-items: flex-end;
                color: #666;
            }
        }

       

        .form_footer{
            margin-top: 20px;
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-weight: 300;
            box-sizing: border-box;

            .link{
                color: #4d83ff;
            }
        }
        
    }
}
</style>